import { render, staticRenderFns } from "./IndependentCta.vue?vue&type=template&id=5bec04a2&scoped=true"
import script from "./IndependentCta.vue?vue&type=script&lang=js"
export * from "./IndependentCta.vue?vue&type=script&lang=js"
import style0 from "./IndependentCta.vue?vue&type=style&index=0&id=5bec04a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec04a2",
  null
  
)

export default component.exports